import { getSpacing } from "@faire/web--source/slate/spacing";
import { EventsThemeShape } from "@faire/web--source/slate/Theme/EventsThemeShape";
import { observer } from "mobx-react";
import * as React from "react";

import { EventsStore } from "@faire/retailer/stores/domain/Events/shared/EventsStore";

interface IProps {
  size?: string;
  customIcon?: React.ComponentType<{ className?: string }>;
  className?: string;
}

const EventIconBase = (props: IProps) => {
  const EventThemeIcon =
    props.customIcon ??
    EventsStore.get().nextOrActiveEventTheme?.eventIcon?.Component ??
    EventsThemeShape.faireMarket.badge;

  const size = props.size ?? getSpacing("2x");
  return (
    <EventThemeIcon
      data-test-id="event-icon"
      width={size}
      height={size}
      className={props.className}
    />
  );
};

export const EventIcon = observer(EventIconBase);
